module.exports = __webpack_public_path__ + "img/js1.69fbf485.png";